<template>
  <div class="scs-contact-list-item">
    <base-list-item
      :class="selected ? 'contact-details selected' : 'contact-details'"
      @click="contactClick"
    >
      <contact-name-and-photo :contact="contact" />
      <div class="phone-and-email">
        <p class="phone">
          {{ source === "search" ? redactedPhone : contact.phoneNumber }}
        </p>
        <p class="email">{{ contact.email }}</p>
      </div>
    </base-list-item>
    <trash-button-expanding
      v-if="tenant && deletable"
      class="contact-trash-button"
      @delete="removeContact"
    />
  </div>
</template>
<script>
import BaseListItem from "../BaseListItem.vue";
import TrashButtonExpanding from "../TrashButtonExpanding.vue";
import ContactNameAndPhoto from "../ListItemComponents/ContactNameAndPhoto.vue";
export default {
  data() {
    return {};
  },
  computed: {
    tenant() {
      if (this.$store.state.user) {
        return (
          this.$store.state.user.userId === this.$store.state.user.tenantId
        );
      } else {
        return false;
      }
    },
    redactedPhone() {
      let numbers = this.contact.phoneNumber.replace(/\D/g, "");
      return numbers.replace(/\d(?=\d{4})/g, "*");
    },
  },
  methods: {
    removeContact() {
      this.$emit("remove-contact");
    },
    contactClick() {
      this.$emit("contact-click");
    },
  },
  // todo : add email component and remove email address from ui
  components: {
    BaseListItem,
    TrashButtonExpanding,
    ContactNameAndPhoto,
  },
  props: {
    contact: {
      type: Object,
    },
    source: {
      type: String,
    },
    selected: {
      type: Boolean,
    },
    deletable: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  emits: ["contact-click", "remove-contact"],
};
</script>
<style scoped>
@media screen {
  .scs-contact-list-item {
    display: flex;
    justify-content: stretch;
    max-width: 100%;
    margin-bottom: 10px;
  }
  .contact-details {
    flex-grow: 1;
    flex-shrink: 1;
    height: 60px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .phone-and-email {
    width: 125px;
    max-width: 40%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .selected {
    border-radius: 8px;
    background-color: var(--contrastColor);
    color: var(--backgroundColor);
  }

  p {
    margin: 0px;
    font-weight: 500;
    font-size: 0.7em;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .contact-trash-button {
    float: right;
  }
  @media (min-width: 550px) {
    .scs-contact-list-item {
      /* height: 65px; */
      margin-bottom: 10px;
    }
  }
}
</style>
